import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "navLink"]

  declare readonly contentTarget: HTMLElement
  declare readonly hasContentTarget: boolean
  declare readonly navLinkTargets: HTMLElement[]

  select(event: Event) {
    event.preventDefault()
    const url = (event.currentTarget as HTMLAnchorElement).href

    this.navLinkTargets.forEach(link => link.classList.remove("active"))
    ;(event.currentTarget as HTMLElement).classList.add("active")

    fetch(url, {
      headers: { "Accept": "text/vnd.turbo-stream.html, text/html, application/xhtml+xml" }
    })
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser()
        const doc = parser.parseFromString(html, "text/html")
        const newContent = doc.querySelector("#car-details")
        if (newContent && this.hasContentTarget) {
          this.contentTarget.innerHTML = newContent.innerHTML
          window.scrollTo({ top: 0, behavior: "smooth" })
        }
      })
  }
}
